import agent from "../../../api/agent";
export const get = (User) =>
  agent.requests.post(`/User/get`, User);
export const list = (pagerInputModel) =>
  agent.requests.post(`/DataTag/getpagedlist`, pagerInputModel);
export const create = (User) => agent.requests.post(`/DataTag/Create`, User);
export const update = (User) => agent.requests.post(`/DataTag/update`, User);

